module.exports = __webpack_public_path__ + "static/media/sneak-peek-background.ba677bd1.png";